<template>
    <div class="color-picker">
        <div style="width:100%" class="select-value">
            {{selectedItem.label}}
            <span class="color-square" :style="{background:selectedItem.code}" :class="{'color-square-white':selectedItem.code=='#FFFFFF'}"></span>
        </div>
        <Select v-model="selectedColorId" style="width:100%" :clearable="clearable" :placeholder="selectedItem.label ? '' : '斑斓'" :disabled="disabled">
            <Option v-for="item in choices" :value="item.value" :key="item.value">
                {{ item.label }}
                 <span class="color-square" :style="{background:item.code}"
                       :class="{'color-square-white':item.code=='#FFFFFF'}"
                       v-if="item.code"
                 >
                 </span>
                <span class="color-square" v-else>
                    <img src="../../images/color_multiple.png" style="vertical-align:middle;">
                </span>
            </Option>
        </Select>
    </div>
</template>
<script>
    export default{
        props: {
            choices: {
                type: Array,
                required: true
            },
            clearable:{
                type:Boolean,
                default:false
            },
            disabled:{
                type:Boolean,
                default:false
            },
            selected: {
                required: false
            },
            filterType:{
                type:String,
                default:'color'
            }
        },
        data(){
            return {
                selectedColorId:this.selected||'',
                selectedItem:{}
            }
        },
        methods:{
            changeLabel(){
                this.selectedItem = this.choices.filter((item)=>{
                    return item.id  == this.selectedColorId;
                })[0]||{};
            }
        },
        watch: {
            selectedColorId: {
                handler: function (val) {
                    this.changeLabel();
                    this.$emit('selectChange', this.filterType, val);
                },
                deep: true
            },
        },
        created(){
            this.changeLabel();
        }
    }
</script>
<style>
    .color-picker .ivu-select-visible .ivu-select-selection{
        box-shadow:none;
    }
    .color-picker .ivu-select .ivu-select-selection{
        color:#353838;
        border:0 none;
    }
    .color-picker .ivu-select.ivu-select-visible{
        border: 1px solid #353838;
        border-radius:4px;
    }
    .color-picker .ivu-select .ivu-select-dropdown{
        max-height:340px;
    }
    .color-picker .ivu-select .ivu-select-dropdown-list .ivu-select-item{
        padding:8px 12px;
        position:relative;
    }
    .color-picker .ivu-select .ivu-select-item-focus, .ivu-select-item:hover{
        background: #F2F4F5;
    }
    .color-picker .ivu-select .ivu-select-selection .ivu-select-placeholder{
        color:#353838;
        font-size: 14px;
    }
    .color-picker .color-square{
        width:12px;
        height:12px;
        border-radius:2px;
        box-sizing:border-box;
        position:absolute;
        top:11px;
        right:8px;
    }
    .color-picker .color-square-white{
        border:1px solid  #F2F4F5;
    }
    .color-picker .ivu-select-single .ivu-select-selection{
        background: transparent;
    }
    .color-picker .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        display:none;
    }
    .color-picker .ivu-select-single .ivu-select-selection  .ivu-select-arrow{
        color:#353838;
        right:12px;
    }
</style>
<style scoped>
    .color-picker{
        position:relative;
        width:110px;
    }
    .select-value{
        position:absolute;
        top:0;
        left:0;
        height:32px;
        line-height: 32px;
        padding-left:10px;
    }
    .select-value .color-square{
        position:absolute;
        top:10px;
        right:32px;
        float:none;
    }
</style>